import fetch from '../utils/fetch';
import { lighthouseURL } from 'endpoints';

function lighthouseService( accessToken, companyId ) {
    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                authorization: `Bearer ${ accessToken }`,
                'company-id': `${ companyId }`
            },
        };
        return fetch( url, options );
    };

    const _fetchJson = async ( url, options = {} ) => {
        if ( options && options.body ) {
            options.headers = {
                ...( options.headers || {} ),
                [ 'content-type' ]: 'application/json'
            };
        }
        const res = await fetchWithAuth( `${ lighthouseURL }${ url }`, options );
        if ( res.ok ) {
            return await res.json();
        } else {
            if ( res.headers.get( 'Content-Type' ).indexOf( 'application/json' ) !== -1 ) {
                const data = await res.json();
                throw {
                    status: res.status,
                    ...data
                };
            }
            const text = await res.text();
            throw text;
        }
    };

    const getSuperUsers = async ( hierarchyId ) => {
        try {
            const { response } = await _fetchJson( `/superusers/hierarchy/${ encodeURIComponent( hierarchyId ) }` );
            return response.persons;
        } catch ( error ) {
            if ( error.status === 404 ) {
                return [];
            }
            throw new Error( 'Unsuccessful response from lighthouse getSuperUsers' );
        }
    };

    const createSuperUsers = async ( hierarchyId, personIds ) => {
        try {
            const res = await _fetchJson( `/superusers/hierarchy/${ encodeURIComponent( hierarchyId ) }`, {
                method: 'POST',
                body: JSON.stringify( {
                    personIds
                } )
            } );
            return res;
        } catch {
            throw new Error( 'Unsuccessful response from lighthouse createSuperUsers' );
        }
    };

    const deleteSuperUsers = async ( hierarchyId ) => {
        try {
            const res = await _fetchJson( `/superusers/hierarchy/${ encodeURIComponent( hierarchyId ) }`, {
                method: 'DELETE'
            } );
            return res;
        } catch {
            throw new Error( 'Unsuccessful response from lighthouse deleteSuperUsers' );
        }
    };

    return {
        getSuperUsers,
        createSuperUsers,
        deleteSuperUsers
    };
}

export default lighthouseService;